import React from 'react';
import { X } from 'lucide-react';

const ModalApple = ({
  isOpen,
  onClose,
  title,
  children,
  footer,
  size = 'md',
  showCloseButton = true,
}) => {
  if (!isOpen) return null;

  const sizeClasses = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    '2xl': 'max-w-2xl',
    full: 'max-w-4xl',
  };

  return (
    <div 
      className="apple-modal-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div 
        className={`apple-modal ${sizeClasses[size] || sizeClasses.md}`}
        style={{ width: '100%' }}
      >
        {/* Header */}
        {(title || showCloseButton) && (
          <div className="apple-modal-header">
            {title && <h2 className="apple-modal-title">{title}</h2>}
            {showCloseButton && (
              <button
                onClick={onClose}
                className="apple-modal-close"
                data-testid="modal-close-btn"
              >
                <X size={16} />
              </button>
            )}
          </div>
        )}

        {/* Body */}
        <div className="apple-modal-body">
          {children}
        </div>

        {/* Footer */}
        {footer && (
          <div className="apple-modal-footer">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
};

export default ModalApple;
